import React from 'react';
import { Button } from 'antd';
import ResumeListSection from '../components/ResumeListSection';
import ResumeEditorForm from '../components/ResumeEditorForm';

/**
 * 通用 list section 视图: 展示态 ↔ 添加态 ↔ 编辑(某条)态。
 * section 模块传入 list 与回调即可,本组件负责三种模式的渲染分支与空态提示。
 */
const ListSectionView = ({
  section,
  list,
  applicantId,
  editingIndex,
  adding,
  options,
  formRef,
  certificateFile,
  setCertificateFile,
  worksFile,
  setWorksFile,
  onTrigger,
  onSubmit,
  onCancel,
  onEdit,
  onDelete,
  onAdd,
  maxCount,
}) => {
  // 添加模式: 在列表底部展示空表单
  if (adding) {
    return (
      <>
        {list.length > 0 ? (
          <ResumeListSection
            section={section}
            list={list}
            applicantId={applicantId}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ) : null}
        <ResumeEditorForm
          ref={formRef}
          section={section}
          initialValues={{}}
          options={options}
          applicantId={applicantId}
          certificateFile={certificateFile}
          setCertificateFile={setCertificateFile}
          worksFile={worksFile}
          setWorksFile={setWorksFile}
          onTrigger={onTrigger}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      </>
    );
  }

  // 编辑某一条: 把 list 切成"前 / 后"两段,表单插在被编辑项的原位置,
  // 与 IntentionsView 的渲染策略保持一致 — 让用户视觉焦点不离开上下文。
  // 之前的实现是 filter 掉编辑项后整段追加在底部,表单永远在最末尾,体验不好。
  if (typeof editingIndex === 'number') {
    const record = list[editingIndex];
    const prevItems = list.slice(0, editingIndex);
    const nextItems = list.slice(editingIndex + 1);
    return (
      <>
        {prevItems.length > 0 ? (
          <ResumeListSection
            section={section}
            list={prevItems}
            applicantId={applicantId}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ) : null}
        <ResumeEditorForm
          ref={formRef}
          section={section}
          initialValues={record}
          options={options}
          applicantId={applicantId}
          certificateFile={certificateFile}
          setCertificateFile={setCertificateFile}
          worksFile={worksFile}
          setWorksFile={setWorksFile}
          onTrigger={onTrigger}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
        {nextItems.length > 0 ? (
          <ResumeListSection
            section={section}
            list={nextItems}
            applicantId={applicantId}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ) : null}
      </>
    );
  }

  // 展示态: 列表 + 添加按钮
  return (
    <>
      {list.length > 0 ? (
        <ResumeListSection
          section={section}
          list={list}
          applicantId={applicantId}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ) : null}
      {list.length === 0 ? (
        <div className="resume-new-empty">暂无{section.title},点击添加完善信息</div>
      ) : null}
      {typeof maxCount === 'number' && list.length < maxCount ? (
        <div className="resume-new-record-add">
          <Button type="dashed" onClick={onAdd}>
            + 添加{section.title} ({list.length}/{maxCount})
          </Button>
        </div>
      ) : typeof maxCount !== 'number' ? (
        <div className="resume-new-record-add">
          <Button type="dashed" onClick={onAdd}>+ 添加{section.title}</Button>
        </div>
      ) : null}
    </>
  );
};

export default ListSectionView;